import React from 'react';

interface LogoProps {
  className?: string;
  variant?: 'light' | 'dark' | 'white';
  showText?: boolean;
  showIcon?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ 
  className = "", 
  variant = 'light',
  showText = true,
  showIcon = true
}) => {
  const isWhite = variant === 'white';
  const brandNavy = '#0A1F3C';

  return (
    <div className={`inline-flex items-center gap-3 ${className} transition-all select-none`}>
      {showIcon && (
        <div className="w-8 h-8 md:w-9 md:h-9 rounded-xl bg-[#0A1428] border border-white/10 flex items-center justify-center shrink-0 shadow-md shadow-blue-900/20 overflow-hidden">
          <svg viewBox="0 0 512 512" className="w-full h-full p-1" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
              d="M 364 176 C 364 126, 320 92, 256 92 C 184 92, 144 130, 144 186 C 144 240, 184 266, 252 284 L 272 290 C 334 306, 368 330, 368 382 C 368 438, 324 476, 256 476 C 180 476, 140 436, 136 380"
              stroke="#FFFFFF"
              strokeWidth="84"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      )}
      
      {showText && (
        <div className={`flex flex-col justify-center ${isWhite ? 'text-white' : 'text-slate-900 dark:text-white'}`}>
          <div className="flex items-center">
            <span className="text-[26px] md:text-[28px] font-black tracking-tighter leading-none" style={{ fontFamily: "'Inter', sans-serif" }}>
              service
            </span>
            <span className={`text-[26px] md:text-[28px] font-black tracking-tighter leading-none ${isWhite ? 'text-white/90' : 'text-blue-600'}`} style={{ fontFamily: "'Inter', sans-serif" }}>
              hub
            </span>
          </div>
          <div className="flex items-center gap-1.5 w-full mt-1 px-0.5">
            <div className={`h-[1px] flex-grow ${isWhite ? 'bg-white/20' : 'bg-slate-200 dark:bg-slate-700'} `} />
            <span className="text-[8px] md:text-[9px] font-black tracking-[0.45em] uppercase leading-none opacity-60 whitespace-nowrap" style={{ fontFamily: "'Inter', sans-serif" }}>
              AFRICA
            </span>
            <div className={`h-[1px] flex-grow ${isWhite ? 'bg-white/20' : 'bg-slate-200 dark:bg-slate-700'} `} />
          </div>
        </div>
      )}
    </div>
  );
};
